import { useCallback } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAuth, useCanWrite } from '../auth';
import { LIBRARY_ID } from '../gallery/config';
import { TaxonomyPage } from './TaxonomyPage';

/**
 * Route de la GESTION DE LA TAXONOMIE (`/outils/taxonomie`, T5 lot B) — « tout dans
 * l'URL ».
 *
 * Rend la PAGE de gestion du vocabulaire sous l'en-tête persistant (× / fil d'Ariane =
 * retour galerie ; ce n'est pas une modale). RÉSERVÉE à l'ACCÈS EN ÉCRITURE (la curation
 * du vocabulaire en est une) ; un simple bénéficiaire de grant, en lecture seule, est
 * redirigé vers l'accueil.
 */
export function TaxonomyRoute(): React.JSX.Element {
  const navigate = useNavigate();
  const { user } = useAuth();
  const libraryId = user?.libraryId ?? LIBRARY_ID;

  const onClose = useCallback(() => navigate('/'), [navigate]);

  // Gating via le helper PARTAGÉ (audit A1). Cette ligne redupliquait la formule
  // `superadmin || libraryId` en OUBLIANT le rôle `admin` — exactement le bug que le
  // docstring de `useCanWrite` raconte et interdit de reproduire. Comme `admin-repo`
  // crée tout compte avec `library_id = NULL`, la formule fautive excluait en pratique
  // TOUS les administrateurs : l'entrée « Taxonomie » du menu (gardée, elle, par
  // `canWrite`) menait à une redirection silencieuse vers l'accueil. Le serveur, lui,
  // autorisait bien l'admin (`routes/tags.ts` = `requireLibraryWrite`).
  const canManage = useCanWrite();
  if (!canManage || !libraryId) return <Navigate to="/" replace />;

  return <TaxonomyPage libraryId={libraryId} onClose={onClose} />;
}
